<template>
	<div class="pedigreeChartContainer">
		<div class="header">
			<span class="pdg-name">{{infoAuth.name}}</span>
			<van-button icon="share-o" plain  type="warning" size="mini" @click="shareGenealogyBook" style="float:right; top:8px; margin-right:5px;">分享</van-button>
			<van-button icon="newspaper-o" plain  type="warning" size="mini" @click="buildGenealogyBook" style="float:right; top:8px; margin-right:5px;" v-if="canVisitPersonal">谱书</van-button>
		</div>

		<div class="empty-node" v-if="rootNode.length==0">
			<van-button type="default" block @click="addRootClans" v-if="!loadByQry&&canAdminPersonal">+</van-button>
		</div>

		<div class="empty" v-if="rootNode.length==0">
			<span v-if="!loadByQry&&!canVisitPersonal">请输入访问密码</span>
			<span v-if="loadByQry">此谱下没有查找到与 “ <span class="skin_color">{{srchKeyWord}}</span> ” 相关族人信息！</span>
		</div>

		<div class="pedigreeChart" ref="pedigree-tree-node">
		
		</div>


		<van-popup v-model="showPersonalPopup" position="bottom" closeable close-icon="close" :style="{ 'height': (winH-100)+'px','bottom':'50px','padding-top': '30px','box-sizing': 'border-box'}">
			<van-tabs v-model="personalActive" sticky v-if="showPersonalPopup">
				<van-tab title="个人信息">
					<personal-info :info="personalInfo" :relation="relationInfo" :pasted.sync="showPastTab" :families="$parent.familyNameIndex" :scsx="$parent.scsx" @callAfterSave="afterSavePersonal"></personal-info>
				</van-tab>
				<van-tab title="教育" :disabled="personalPopupTab[0]">
					<edu :p_id="actionPsrId" ></edu>
				</van-tab>
				<van-tab title="置业" :disabled="personalPopupTab[1]">
					<house :p_id="actionPsrId" :pdg_p_id="infoAuth.personal_id" :pdg_num="infoAuth.pedigree_num"></house>
				</van-tab>
				<van-tab title="履历" :disabled="personalPopupTab[2]">
					<vitae :p_id="actionPsrId" ></vitae>
				</van-tab>
				<van-tab title="账务记录" :disabled="personalPopupTab[3]">
					<finance :fid="actionPsrId" :types="'personal'"></finance>
				</van-tab>
				<van-tab title="过继关系" :disabled="personalPopupTab[4]" v-if="personalInfo.sex=='M'">
					<adpot :p_id="actionPsrId" :family_name="infoAuth.family_name" :pedigree_num="infoAuth.pedigree_num"></adpot>
				</van-tab>
				<van-tab title="过往信息" v-if="showPastTab" :disabled="personalPopupTab[5]">
					<pasted-info :p_id="actionPsrId" :scsx="$parent.scsx" @callAfterSave="afterSavePastinfo"></pasted-info>
				</van-tab>
			</van-tabs>
		</van-popup>

		<van-popup v-model="showEditInfo" round position="bottom" :style="{ 'max-height': '80%' ,'padding-top':'10px' ,'padding-bottom':'50px'}">
			<pedigree-info v-if="showEditInfo" :pdgInfo="pedigreeInfo" :imgList="imgList" :families="$parent.familyNameIndex" :edit="editPedigreeInfo" @callAfterSave="afterSavePedigree"></pedigree-info>
		</van-popup>

		<div class="pedigree-admin skin_border" v-if="u_id&&token&&infoAuth.admin_pwd&&!canAdminPersonal"><!--  -->
			<img src="../../assets/img/icon/menu/passw.png" @click='showChkAdminPwd=true' />
		</div>
		<div class="pedigree-visit skin_border"  v-if="infoAuth.visit_pwd&&!canVisitPersonal"><!-- -->
			<van-icon name="eye-o" @click='showChkVisitPwd=true' class="skin_color" size="24px"/>
		</div>

		<div v-show="showSetPwd||showChkVisitPwd||showChkAdminPwd" class="reset-pwd-popup" :style="(showVisitKeyboard||showAdminKeyboard)?'bottom:290px':''">
			<van-row v-show="showSetPwd||showChkVisitPwd">
				<van-col span="6">访问密码：
				</van-col>
				<van-col span="18">
					<van-password-input
					  :value="pwdVisit"
					  :focused="showVisitKeyboard"
					  @focus="showKeyboard(1)"
					/>
				</van-col>
			</van-row>
			<van-row v-show="showSetPwd||showChkAdminPwd">
				<van-col span="6">管理密码：
				</van-col>
				<van-col span="18">
					<van-password-input
					  :value="pwdAdmin"
					  :focused="showAdminKeyboard"
					  @focus="showKeyboard(2)"
					/>
				</van-col>
			</van-row>
			<van-row v-show="showSetPwd">
				<van-col span="10">
					<van-button type="default" block  @click="cancleSetPwd">取消</van-button>
				</van-col>
				<van-col span="1">
				</van-col>
				<van-col span="13">
					<van-button type="primary" block  @click="saveResetPwd()">保存</van-button>
				</van-col>
			</van-row> 
			<van-row v-show="showChkVisitPwd||showChkAdminPwd">
				<van-col span="10">
					<van-button type="default" block  @click="cancleSetPwd">取消</van-button>
				</van-col>
				<van-col span="1">
				</van-col>
				<van-col span="13">
					<van-button type="primary" block  @click="confirmChkPwd">确定</van-button>
				</van-col>
			</van-row> 
			
		</div>

		<van-number-keyboard
			ref="visitKeyboard"
			v-model="pwdVisit"
			length=6
			:show="showVisitKeyboard"
			@blur="showVisitKeyboard = false"
		/>

		<van-number-keyboard
			ref="adminKeyboard"
			v-model="pwdAdmin"
			length=6
			:show="showAdminKeyboard"
			@blur="showAdminKeyboard = false"
		/>

		<van-share-sheet
		  v-model="showAction"
		  :title="actionTitle"
		  :options="actionOptions"
		  :style="{bottom:'50px'}"
		  @select="onClkOption"
		/>

		<van-popup v-model="showPedigreeSourcePopup" round position="bottom" closeable close-icon="close" :style="{ 'height': (winH-100)+'px','bottom':'50px','padding-top': '50px','box-sizing': 'border-box'}">
			<pedigree-source :pedigree_id="pdg_id" :pedigree_num="infoAuth.pedigree_num"></pedigree-source>
		</van-popup>


		<van-popup v-model="showGenealogyBookPopup" position="bottom" :style="{ 'height': (winH-100)+'px','bottom':'50px','padding-top': '20px','box-sizing': 'border-box'}">
			<genealogy-book :pedigree_id="pdg_id" :pedigree_num="infoAuth.pedigree_num" :book_name="infoAuth.name" :scsx="$parent.scsx" :show_book="showGenealogyBookPopup"></genealogy-book>
		</van-popup>


		<share :showShareSheet.sync="showShareSheet" :shareUrl="shareQRCodeUrl" :shareConfig="shareConfig" :botm="50" v-show="showShareSheet" v-if="initShareSheet"/>
	</div>
</template>

<script>
	import { Col, Row,PasswordInput, NumberKeyboard,Sticky,ShareSheet  } from 'vant';
	import { chkWeiXin } from "@/utils/common.js";
	import md5 from "js-md5";
	import PedigreeInfo from "@/components/Clans/PedigreeInfo";
	import PersonalInfo from "@/components/Clans/PersonalInfo";
	import Education from "@/components/Clans/Education";
	import House from "@/components/Clans/House";
	import Vitae from "@/components/Clans/Vitae";
	import Adpot from "@/components/Clans/Adpot";
	import PedigreeSource from "@/components/Clans/PedigreeSource";
	import Finance from "@/components/Clans/Finance";
	import PastedInfo from "@/components/Clans/PastedInfo";
	import GenealogyBook from "@/components/Clans/GenealogyBook";
	import Share from "@/components/Commom/Share";

	export default {
		name: "PedigreeTree",
		components: {
			"van-row":Row,
			"van-col":Col,
			"pedigree-info":PedigreeInfo,
			"personal-info":PersonalInfo,
			"van-password-input":PasswordInput,
			"van-number-keyboard":NumberKeyboard,
			"van-sticky":Sticky,
			"van-share-sheet":ShareSheet,
			"edu":Education,
			"house":House,
			"vitae":Vitae,
			"adpot":Adpot,
			"pedigree-source":PedigreeSource,
			"finance":Finance,
			"pasted-info":PastedInfo,
			"genealogy-book":GenealogyBook,
			"share":Share
		},
		props:['keyword'],
		data() {
			return {
				winH:300,
				u_id: localStorage.getItem("u_id"),
				token: localStorage.getItem(localStorage.getItem("u_id")+"token"),
				attach_url: this.Conf.serverPre,
				srchKeyWord:'',
				pdg_id:null,
				qryPdgOnly:0,
				showPersonalPopup:false,
				personalPopupTab:[true,true,true,true,true,true],
				personalActive:0,
				showPastTab:false,
				showEditInfo:false,
				pedigreeInfo:{},
				coverImg:require("../../assets/img/clans/cover.jpg"),
				coverNormalImg:this.Conf.clientOrigin+'/upload/cover_normal.jpg',
				imgList:[],
				infoAuth:{},

				rootNode:[],
				initDeep:1,//默认自动加载3层级数据
				deepLoadIds:[],
				loadClansAuto:true,

				showSetPwd:false,
				showChkVisitPwd:false,
				showChkAdminPwd:false,
				pwdVisit:'',
				pwdAdmin:'',
				showVisitKeyboard:false,
				showAdminKeyboard:false,

				canVisitPersonal:false,
				canAdminPersonal:false,
				defHeadImg:{
					'M':require("../../assets/img/clans/M.png"),
					'F':require("../../assets/img/clans/F.png")
				},

				loadByQry:false,

				showAction:false,
				actionOptions: [],
				personalInfo:{},
				relationInfo:{},

				showActions:false,
				actionPsrId:0,
				actionTitle:'',
				actionParams:{},

				showPedigreeSourcePopup:false,
				showGenealogyBookPopup:false,
				editPedigreeInfo:true,

				
				showShareSheet:false,
				shareQRCodeUrl:'',
				shareConfig:{},
				//shareDesc:'以客观、真实记录氏族的源流、迁徙、繁衍与发展；延续宗族记忆、构建历史文本、族人追求集体荣誉感、依附感和归宿感；弘扬社会主义核心价值观、传承中华姓氏文明与家风'
				shareDesc:'家族支叶硕茂、周识不全，家人、置业取名不重复，延续宗族记忆！',
				initShareSheet:false
			};
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.winH = `${document.documentElement.clientHeight}`;
			window.onresize = function temp() {
				this.winH = `${document.documentElement.clientHeight}`;
			};
			
		},
		methods: {
			chkLogined(msg){
				if(!(this.u_id && this.token)){
					this.$dialog
					.confirm({
						title: "温馨提醒",
						message: msg||"登录后即可操作",
						showCancelButton:true,
						confirmButtonText:'马上登录',
						cancelButtonText:'再看看'
					})
					.then(() => {
						this.$router.push({ path: "/Login" });
						return false;
					})
					.catch(error => {
						return false;
					});
					return false;
				}
				return true;
			},
			compNodeContent(n){
				if(n.birthdate){
					return n.birthdate;
				}
				if(n.birthday){
					let days = n.birthday.split(" ")[0].split("-");
					let cnt = n.calendar=="L"?"阴历":"阳历";
					cnt += days[0]+'年';
					cnt += n.leep_month?"润":"";
					cnt += days[1]+'月';
					cnt += days[2]+'日';
					if(n.hours){
						cnt += this.$parent.scsx[n.hours]['sc']
					}
					return cnt;
				}
				return '生辰不详';
			},
			getCountAge(birthday){
				let birthYear = parseInt(birthday.split(" ")[0].split("-"));
				return new Date().getFullYear()-birthYear;
			},
			initNodeElm(n, ismeta, isroot, isQryUp, childLen){
				let elm = '		<div id="clans_' + n.id + '" class="node'+(n.sex=="M"?" man":(n.sex=="F"?" woman":"")) + (n.pasted?' past':'') +'">';//(n.pasted?'past':(n.sex=="M"?"man":(n.sex=="F"?"woman":"")))
				elm += '			<div class="title">';
				elm += '				<span>' + ((this.infoAuth.family_name!=n.surname&&n.surname)?n.surname:'')+n.name + '</span>';
				elm += '			</div>';
				elm += '			<div class="content">' + (n.is_adpot==1?'志在外詳':this.compNodeContent(n)) + '</div>';
				if(this.canAdminPersonal || n.u_id == this.u_id || n.data_u_id == this.u_id){
					elm += '			<i class="edge editEdge fa fa-chevron-edit"';
					if(this.canAdminPersonal){
						elm += ' onclick="act2Personal(event, 0, '+n.id+')"';
					}
					elm += '></i>';
				}

				elm += '			<i class="edge verticalEdge topEdge fa fa-chevron-up'+(n.up_id?" fa-rotate-vertical":"")+'" onclick="act2ClansChart(event, this, \''+n.id+'\', \'up\')"></i>';
				elm += '			<i class="edge verticalEdge bottomEdge fa fa-chevron-down" onclick="act2ClansChart(event, this, \''+n.id+'\', \'down\')"></i>';
				elm += '			<i class="edge horizontalEdge rightEdge fa fa fa-chevron-right" onclick="act2ClansChart(event, this, '+n.id+', \'right\')"></i>';
				elm += '			<i class="edge horizontalEdge leftEdge fa fa fa-chevron-left" onclick="act2ClansChart(event, this, '+n.id+', \'left\')"></i>';

				elm += '			<i class="edge newEdge fa fa-chevron-woman" onclick="act2Personal(event, 1, '+n.id+')"><span>添加配偶</span></i>';
				elm += '			<i class="edge newEdge fa fa-chevron-mother" onclick="act2Personal(event, -1, '+n.id+')"><span>添加母亲</span></i>';
				elm += '			<i class="edge newEdge fa fa-chevron-child" onclick="act2Personal(event, 2, '+n.id+')"><span>添加子女</span></i>';
				elm += '			<i class="edge newEdge fa fa-chevron-man" onclick="act2Personal(event, 1, '+n.id+')"><span>添加配偶</span></i>';
				elm += '			<i class="edge newEdge fa fa-chevron-man2" onclick="act2Personal(event, 3, '+n.id+')"><span>添加配偶</span></i>';

				elm += '			<div class="head-img"';
				if(this.canAdminPersonal || n.u_id == this.u_id || n.data_u_id == this.u_id){
					elm += ' onclick="act2Personal(event,0, '+n.id+')"';
				}
				elm += '><img src="'+(n.head_img?(n.head_img.indexOf('http')==-1?(this.attach_url+n.head_img):n.head_img):this.defHeadImg[n.sex])+'" class="'+(n.pasted?'past':'')+'"/>';
				elm += '		</div>';
				return elm;
			},
			initClkAttribute(n, meta, o){
				let atbs = ' psr_id="';
				atbs += n.id;
				atbs += '" sex="';
				atbs += n.sex;
				atbs += '" surname="';
				atbs += n.surname?n.surname:'';
				atbs += '" name="';
				let vname = '';//(this.infoAuth.family_name!=n.surname&&n.surname)?n.surname:'';
				atbs += vname;
				atbs += n.name;
				atbs += '" types="';
				let vtypes = isNaN(parseInt(n.types))?0:parseInt(n.types);
				atbs += vtypes;
				atbs += '" jishi="';
				let vjishi = isNaN(parseInt(n.jishi))?0:parseInt(n.jishi);
				atbs += vjishi;
				atbs += '" in_laws="';
				let vin_laws = isNaN(parseInt(n.in_laws))?0:parseInt(n.in_laws);
				atbs += vin_laws;
				atbs += '" up_id="';
				let vup_id = isNaN(parseInt(n.up_id))?0:parseInt(n.up_id);
				atbs += vup_id;
				atbs += '" meta="';
				atbs += meta;
				atbs += '" ups="';
				let vups = isNaN(parseInt(n.ups))?0:parseInt(n.ups);
				atbs += vups;
				atbs += '" nexts="';
				let vnexts = isNaN(parseInt(n.nexts))?0:parseInt(n.nexts);
				atbs += vnexts;
				atbs += '" adpots="';
				let vadpots = isNaN(parseInt(n.adpots))?0:parseInt(n.adpots);
				atbs += vadpots;
				atbs += '" pasted="';
				let vpasted = isNaN(parseInt(n.pasted))?0:parseInt(n.pasted);
				atbs += vpasted;
				atbs += '" is_adpot="';
				let vis_adpot = isNaN(parseInt(n.is_adpot))?0:parseInt(n.is_adpot);
				atbs += vis_adpot;
				atbs += '" adp_id="';
				let vadp_id = isNaN(parseInt(n.adp_id))?0:parseInt(n.adp_id);
				atbs += vadp_id;
				atbs += '" rel="';
				let vrel = isNaN(parseInt(n.rel))?0:parseInt(n.rel);
				atbs += vrel;
				atbs += '"';
				if(o){
					o.setAttribute('psr_id', n.id);
					o.setAttribute('sex', n.sex);
					o.setAttribute('surname', n.surname?n.surname:'');
					o.setAttribute('name', vname+n.name);
					o.setAttribute('types', vtypes);
					o.setAttribute('jishi', vjishi);
					o.setAttribute('in_laws', vin_laws);
					o.setAttribute('up_id', vup_id);
					o.setAttribute('meta', meta);
					o.setAttribute('ups', vups);
					o.setAttribute('nexts', vnexts);
					o.setAttribute('adpots', vadpots);
					o.setAttribute('pasted', vpasted);
					o.setAttribute('is_adpot', vis_adpot);
					o.setAttribute('adp_id', vadp_id);
					o.setAttribute('rel', vrel);
				}
				return atbs;
			},
			initTableElm(n, isroot, isQryUp, childLen){
				let tbElm = document.createElement("table");
				let tbodyElm = document.createElement("tbody");
				let trElm = document.createElement("tr");
				let tdElm = document.createElement("td");
				tdElm.style.padding = "0 15px"

				let elm = '';
				elm += '<table id="clans_tb_'+n.id+'">';
				elm += '	<tbody>';
				elm += '	<tr>';
				elm += '		<td onclick="clkPersonal(this)" ';
				elm +=				this.initClkAttribute(n,0,null);
				elm += '		>';
				elm +=				this.initNodeElm(n, false, isroot, isQryUp, childLen);
				elm += '		</td>';
				elm += '		<td id="clans_meta_'+n.id+'"></td>';
				elm += '	</tr>';
				elm += '	</tbody>';
				elm += '</table>';
				tdElm.innerHTML = elm;

				trElm.appendChild(tdElm);
				tbodyElm.appendChild(trElm);
				tbElm.appendChild(tbodyElm);
				return tbElm;

			},
			initMetaElm(id){
				let mobj = document.createElement('div');
				mobj.setAttribute('class',"meta hidden");
				//mobj.style.display = 'none';
				let elm = '<table>';
				elm += '	<tbody id="clans_meta_tbody_'+id+'">';
				elm += '	<tr>';
				/**
				elm += '		<td rowspan="2">';
				elm += '			<div class="line">&nbsp;</div>';
				elm += '		</td>';
				*/
				elm += '		<td class="bottom">';
				elm += '			<div style="width:20px">&nbsp;</div>';
				elm += '		</td>';
				elm += '		<td class="bottom"><div style="width:20px">&nbsp;</div></td>';
				elm += '		<td rowspan="2" onclick="clkPersonal(this)">';// style="padding-bottom:20px;"
				elm += '		</td>';
				elm += '	</tr>';
				elm += '	<tr>';
				elm += '		<td class="top">&nbsp;</td>';
				elm += '		<td class="top">&nbsp;</td>';
				elm += '	</tr>';
				elm += '	</tbody>';
				elm += '</table>';
				mobj.innerHTML = elm;
				document.getElementById('clans_meta_'+id).appendChild(mobj);
				if(document.getElementById('clans_tb_'+id).parentNode.parentNode.parentNode.parentNode.parentNode.tagName == "TD"){
					document.getElementById('clans_meta_tbody_'+id).children[0].children[1].setAttribute('class','left leftline bottom');
				}
				document.getElementById("clans_"+id).parentNode.setAttribute('metas',0);
			},
			addMetaElm(id, metas, isQryUp){
				if(metas && metas.length > 0){
					let tbElm = document.getElementById("clans_"+id).parentNode;
					let metaElm = document.getElementById("clans_meta_"+id);
					//metaElm.querySelector('.meta').style.display = 'block';
					metaElm.querySelector('.meta').setAttribute('class','meta')
					let tbodyElm = document.getElementById('clans_meta_tbody_'+id);
					let startInd = 0, trobj = null, tdobj = null;
					let metaNum = parseInt(tbElm.getAttribute('metas'));
					if(metaNum==0){
						startInd = 1;
						tbodyElm.setAttribute('metas',startInd);
						this.initClkAttribute(metas[0],1,tbodyElm.children[0].children[2]);
						tbodyElm.children[0].children[2].innerHTML = this.initNodeElm(metas[0], true, false, isQryUp, 0);
						metaNum++;
						tbElm.setAttribute('metas',metaNum);
					}
					if(metas.length > startInd){
						for(var i=startInd,il=metas.length; i<il; i++){
							//tbodyElm.children[0].children[0].setAttribute('rowspan',parseInt(tbodyElm.children[0].children[0].getAttribute('rowspan'))+2);
							trobj = document.createElement('tr');
							tdobj = document.createElement('td');
							if(metaNum == 1){
								tdobj.setAttribute('class',"top");
							}
							tdobj.innerHTML = "&nbsp;";
							trobj.appendChild(tdobj);

							tdobj = document.createElement('td');
							tdobj.setAttribute('class',"top left");
							tdobj.innerHTML = "&nbsp;";
							trobj.appendChild(tdobj);

							tbodyElm.insertBefore(trobj, tbodyElm.children[tbodyElm.children.length-1]);

							trobj = document.createElement('tr');
							tdobj = document.createElement('td');
							tdobj.innerHTML = "&nbsp;";
							trobj.appendChild(tdobj);

							tdobj = document.createElement('td');
							tdobj.setAttribute('class',"bottom left");
							tdobj.innerHTML = "&nbsp;";
							trobj.appendChild(tdobj);

							tdobj = document.createElement('td');
							tdobj.setAttribute('rowspan', 2);
							tdobj.onclick = Function("clkPersonal(this)");
							//tdobj.style.paddingBottom = "20px";
							trobj.appendChild(tdobj);
							this.initClkAttribute(metas[startInd], 1, tdobj);
							tdobj.innerHTML = this.initNodeElm(metas[i], true, false, isQryUp, 0);
							tbodyElm.insertBefore(trobj, tbodyElm.children[tbodyElm.children.length-1]);

							metaNum++;
							tbElm.setAttribute('metas',metaNum);
						}
						if(metaNum>=2){
							tdobj = document.createElement('td');
							tdobj.innerHTML = "&nbsp;";
							tbodyElm.children[tbodyElm.children.length-1].insertBefore(tdobj,tbodyElm.children[tbodyElm.children.length-1].children[0]);
						}
					}
					let rightArown = tbElm.querySelector('.fa-chevron-right');
					if(rightArown){
						if(rightArown.getAttribute('class').indexOf('fa-rotate-horizontal')==-1){
							rightArown.setAttribute('class',rightArown.getAttribute('class')+' fa-rotate-horizontal');
						}
					}
				}
			},
			initChildElm(id){	
				let tbobj = document.getElementById('clans_tb_'+id);
				let tbodyObj = tbobj.parentNode.parentNode.parentNode;
				tbobj.parentNode.setAttribute('colspan',2);
				let tdobj = null;

				let trobj = document.createElement('tr');
				trobj.setAttribute('class',"lines hidden");
				tdobj = document.createElement('td');
				tdobj.setAttribute('colspan',2);
				let dwobj = document.createElement('div');
				dwobj.setAttribute('class',"down");
				tdobj.appendChild(dwobj);
				trobj.appendChild(tdobj);
				tbodyObj.appendChild(trobj);

				trobj = document.createElement('tr');
				trobj.setAttribute('class',"lines hidden");
				tdobj = document.createElement('td');
				tdobj.setAttribute('class',"right");
				tdobj.innerHTML = "&nbsp;";
				trobj.appendChild(tdobj);
				tbodyObj.appendChild(trobj);

				tdobj = document.createElement('td');
				tdobj.setAttribute('class',"left");
				tdobj.innerHTML = "&nbsp;";
				trobj.appendChild(tdobj);
				tbodyObj.appendChild(trobj);

				trobj = document.createElement('tr');
				trobj.setAttribute('class',"hidden");
				tbodyObj.appendChild(trobj);
				document.getElementById("clans_"+id).parentNode.setAttribute('childs',0);
			},
			addChildElm(id, childs, isQryUp){
				if(childs && childs.length > 0){
					if(document.getElementById('clans_meta_tbody_'+id)){
						document.getElementById('clans_meta_tbody_'+id).children[document.getElementById('clans_meta_tbody_'+id).children.length-1].children[1].setAttribute('class','left leftline top');
					}
					let tbobj = document.getElementById('clans_tb_'+id);
					let tbodyObj = tbobj.parentNode.parentNode.parentNode;

					tbodyObj.children[1].setAttribute('class','lines');
					tbodyObj.children[2].setAttribute('class','lines');
					tbodyObj.children[3].setAttribute('class','');
					let tdobj;
					let tbElm = document.getElementById("clans_"+id).parentNode;
					for(var i=0,il=childs.length; i<il; i++){
						if(tbodyObj.children[tbodyObj.children.length-1].children.length*2 == tbodyObj.children[2].children.length){
							tdobj = document.createElement('td');
							tdobj.setAttribute('class','left top');
							tdobj.innerHTML = "&nbsp;";
							tbodyObj.children[2].insertBefore(tdobj, tbodyObj.children[2].children[tbodyObj.children[2].children.length-1]);

							tdobj = document.createElement('td');
							tdobj.setAttribute('class','right top');
							tdobj.innerHTML = "&nbsp;";
							tbodyObj.children[2].insertBefore(tdobj, tbodyObj.children[2].children[tbodyObj.children[2].children.length-1]);
						}
						tdobj = document.createElement('td');
						tdobj.setAttribute('colspan',2);
						tbodyObj.children[tbodyObj.children.length-1].appendChild(tdobj);
						this.appendElm(tdobj, childs[i], false, isQryUp, il);

						tbElm.setAttribute('childs',parseInt(tbElm.getAttribute('childs'))+1);
					}

					let cldLen = tbodyObj.children[tbodyObj.children.length-1].children.length;
					tbobj.parentNode.setAttribute('colspan', cldLen*2);
					tbodyObj.children[1].children[0].setAttribute('colspan', cldLen*2);
					

					if(cldLen > 1){
						let leftArowns = tbodyObj.querySelectorAll('.fa-chevron-left');
						if(leftArowns){
							for(var i=0,il=leftArowns.length; i<il; i++){
								if(leftArowns[i].getAttribute('class').indexOf('fa-rotate-horizontal')==-1){
									leftArowns[i].setAttribute('class',leftArowns[i].getAttribute('class')+' fa-rotate-horizontal');
								}
							}
						}
					}

					let downArown = tbobj.querySelector('.fa-chevron-down');
					if(downArown.getAttribute('class').indexOf('fa-rotate-vertical')==-1){
						downArown.setAttribute('class',downArown.getAttribute('class')+' fa-rotate-vertical');
					}
				}
			},
			appendElm(obj, n, isroot, isQryUp, childLen){
				obj.appendChild(this.initTableElm(n, isroot, isQryUp, childLen));
				this.initMetaElm(n.id);
				this.initChildElm(n.id);
			},
			appendRelationshipElm(id, metas, childs, isQryUp){
				this.addMetaElm(id, metas, isQryUp);
				
				this.addChildElm(id, childs, isQryUp);
			},
			getStateConfigs(){
				const confs = this.$store.state.common.configs;
				if(confs){
					if(confs.attach_url){
						this.attach_url = confs.attach_url.values;
					}
				}else{
					setTimeout(() => {
						this.getStateConfigs();
					},1000);
				}
			},
			chkPedigreeAuth(){
				var params = {
					u_id: this.u_id,
					token: this.token,
					id: this.pdg_id
				};
				var url = this.Conf.serverUrl + "clans/chkPedigreeAuth?num="+Math.random();
				let that = this;
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.code == 200) {
						that.infoAuth = response.data.data;
						let hisVisitAuth = (localStorage.getItem("clans_visit_pedigree")||"").split(",");
						let hisAdminAuth = (localStorage.getItem("clans_admin_pedigree")||"").split(",");

						if(that.infoAuth.infoAuth || !that.infoAuth.visit_pwd || hisVisitAuth.indexOf(that.pdg_id) > -1){
							that.canVisitPersonal = true;
							that.loadPedigreePersonal(null,null,0);
						}
						that.$parent.infoAuth = that.infoAuth.infoAuth;


						if(!that.infoAuth.infoAuth && that.infoAuth.visit_pwd && !that.canVisitPersonal){
							that.showChkVisitPwd = true;
							that.pwdVisit = "";
							that.showVisitKeyboard = true;
						}
						if(that.infoAuth.infoAuth || !that.infoAuth.admin_pwd || hisAdminAuth.indexOf(that.pdg_id) > -1){
							that.canAdminPersonal = true;
						}

						that.shareConfig = {
							title: '家人们，一起来完善【'+that.infoAuth.name+'】吧', // 分享标题
							desc: that.shareDesc, // 分享描述
							link: that.shareQRCodeUrl, // 分享链接
							imgUrl: that.infoAuth.img?(that.attach_url+that.infoAuth.img):that.coverNormalImg // 分享图标
						};
						that.initShareSheet = true;
					}
				})
				.catch(error => {});
			},
			onEdit(){
				var params = {
					u_id: this.u_id,
					token: this.token,
					id: this.pdg_id
				};
				var url = this.Conf.serverUrl + "clans/pedigreeInfo?num="+Math.random();
				let that = this;
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.code == 200) {
						if(response.data.info){
							that.pedigreeInfo = response.data.info;
							if(that.pedigreeInfo.img){
								that.imgList = [{url:that.attach_url+that.pedigreeInfo.img, isImage: true}];
							}else{
								that.imgList = [{url:require("../../assets/img/clans/cover.jpg"), isImage: true}];
							}
							that.editPedigreeInfo = true;
							that.showEditInfo = true;
						}
					}else if(response.data.msg){
						that.$toast.fail(response.data.msg);
					}
				})
				.catch(error => {});
			},
			afterSavePedigree(n){
				this.showEditInfo = false;
				if(!this.editPedigreeInfo){
					this.$router.push({path:'/Clans'});
					return false;
				}
				if(n){
					this.infoAuth.family_name = n.family_name;
					this.infoAuth.name = n.name;
					this.infoAuth.area = n.area;
				}
			},
			reshowPersonalInfo(info){
				let clanElm = document.getElementById('clans_'+info.id);
				clanElm.parentNode.setAttribute('surname',info.surname?info.surname:'');
				clanElm.parentNode.setAttribute('name',info.name?info.name:'');
				let nname = ((info.surname&&this.infoAuth.family_name!=info.surname)?info.surname:'')+info.name;
				clanElm.querySelector('.title').innerHTML = '<span>' + nname + '</span>';
				clanElm.querySelector('.content').innerHTML = this.compNodeContent(info);
				if(info.head_img){
					clanElm.querySelector('head-img').innerHTML = '<img src="'+(info.head_img.indexOf('http')==-1?(this.attach_url+info.head_img):info.head_img)+'"/>';
				}
				clanElm = document.getElementById('clans_r_'+info.id);
				if(clanElm){
					clanElm.querySelector('.title').innerHTML = '<span>' + nname + '</span>';
					if(info.head_img){
						clanElm.querySelector('head-img').innerHTML = '<img src="'+(info.head_img.indexOf('http')==-1?(this.attach_url+info.head_img):info.head_img)+'"/>';
					}
				}
			},
			exchangePersonal(id, relationId){
				let clanElm = document.getElementById('clans_' + id);
				let relatClanElm = document.getElementById('clans_' + relationId);
				let clanParentElm = clanElm.parentNode;
				let relatClanParentElm = relatClanElm.parentNode;
				relatClanParentElm.appendChild(document.getElementById('clans_' + id));
				clanParentElm.appendChild(document.getElementById('clans_' + relationId));

				let atrKeys = ['psr_id','sex','name','types','in_laws'];//,'unmeta','meta','ups','qrydown','qryup'
				let tmp = null;
				for(var i=0,il=atrKeys.length; i<il; i++){
					tmp = clanParentElm.getAttribute(atrKeys[i]);
					clanParentElm.setAttribute(atrKeys[i],relatClanParentElm.getAttribute(atrKeys[i]));
					relatClanParentElm.setAttribute(atrKeys[i],tmp);
				}

				clanParentElm = clanElm.parentNode;
				relatClanParentElm = relatClanElm.parentNode;
				

				clanElm.querySelector('.title').innerHTML = '<span>' + ((clanParentElm.getAttribute('surname')!=this.infoAuth.family_name?clanParentElm.getAttribute('surname'):'') + clanParentElm.getAttribute('name')) + '</span>';
				relatClanElm.querySelector('.title').innerHTML = '<span>' + ((relatClanParentElm.getAttribute('surname')!=this.infoAuth.family_name?relatClanParentElm.getAttribute('surname'):'') + relatClanParentElm.getAttribute('name')) + '</span>';
				
				let tmlcls = clanElm.getAttribute('class');
				if(clanParentElm.getAttribute('sex') == "M"){
					tmlcls = tmlcls.replace('woman','');
					if(tmlcls.indexOf('man')==-1){
						tmlcls += ' man';
					}
					clanElm.setAttribute('class',tmlcls);
				}
				if(clanParentElm.getAttribute('sex') == "F"){
					tmlcls = tmlcls.replace('man','');
					if(tmlcls.indexOf('woman')==-1){
						tmlcls += ' woman';
					}
					clanElm.setAttribute('class',tmlcls);
				}
				//clanElm.setAttribute('class','node ' + (clanParentElm.getAttribute('sex')=='M'?'man':(clanParentElm.getAttribute('sex')=='F'?'woman':'')));
				tmlcls = relatClanElm.getAttribute('class');
				if(relatClanParentElm.getAttribute('sex') == "M"){
					tmlcls = tmlcls.replace('woman','');
					if(tmlcls.indexOf('man')==-1){
						tmlcls += ' man';
					}
					relatClanElm.setAttribute('class',tmlcls);
				}
				if(relatClanParentElm.getAttribute('sex') == "F"){
					tmlcls = tmlcls.replace('man','');
					if(tmlcls.indexOf('woman')==-1){
						tmlcls += ' woman';
					}
					relatClanElm.setAttribute('class',tmlcls);
				}
				//relatClanElm.setAttribute('class','node ' + (relatClanParentElm.getAttribute('sex')=='M'?'man':(relatClanParentElm.getAttribute('sex')=='F'?'woman':'')));
				
				let resetId = relationId, attrId = id;
				if(!document.getElementById('clans_tb_' + relationId)){
					resetId = id;
					attrId = relationId;
				}
				document.getElementById('clans_tb_' + resetId).setAttribute('id', 'clans_tb_' + attrId);
				document.getElementById('clans_meta_' + resetId).setAttribute('id', 'clans_meta_' + attrId);
				document.getElementById('clans_meta_tbody_' + resetId).setAttribute('id', 'clans_meta_tbody_' + attrId);

			},
			afterSavePersonal(data){
				//this.showPersonalPopup = false;
				this.personalPopupTab = [false,false,false,false,false,false];
				let dinfo = data.info;
				if(data.update){
					this.reshowPersonalInfo(dinfo);
					if(data.position == 'exchange'){
						this.exchangePersonal(dinfo.id, data.relationUserId)
					}
				}else{
					if(data.position == 'top'){
						this.appendElm(this.$refs['pedigree-tree-node'], dinfo, true, false);
						document.getElementById('clans_'+data.relationUserId).parentNode.setAttribute('up_id',dinfo.id);
						let childElm = document.getElementById('clans_tb_'+data.relationUserId).parentNode.parentNode.parentNode.parentNode;
						
						if(document.getElementById('clans_meta_tbody_'+data.info.id)){
							document.getElementById('clans_meta_tbody_'+data.info.id).children[document.getElementById('clans_meta_tbody_'+data.info.id).children.length-1].children[0].setAttribute('class','left leftline top');
						}
						let tbobj = document.getElementById('clans_tb_'+data.info.id);
						let tbodyObj = tbobj.parentNode.parentNode.parentNode;

						let tdobj = document.createElement('td');
						tdobj.setAttribute('colspan',2);
						tdobj.appendChild(childElm)
						tbodyObj.children[tbodyObj.children.length-1].appendChild(tdobj);

						tbodyObj.children[1].setAttribute('class','lines');
						tbodyObj.children[2].setAttribute('class','lines');
						tbodyObj.children[3].setAttribute('class','');

						document.getElementById('clans_tb_'+data.relationUserId).parentNode.setAttribute('up_id', dinfo.id);
						document.getElementById('clans_tb_'+data.relationUserId).parentNode.setAttribute('qryup', 1);
						document.getElementById('clans_tb_'+data.relationUserId).parentNode.setAttribute('childs', 1);

					}else if(data.position == 'bottom'){
						let pntId = data.relationUserId;
						let metaNode = document.getElementById('clans_'+data.relationUserId).parentNode;
						if(metaNode.getAttribute('meta')==1 && metaNode.getAttribute('up_id')){
							pntId = metaNode.getAttribute('up_id');
						}
						dinfo.up_id = pntId;
						this.addChildElm(pntId, [dinfo], false);
					}else if(data.relationUserId){//meta
						dinfo.up_id = data.relationUserId;
						this.addMetaElm(data.relationUserId, [dinfo], false);
						if(data.position == 'left'){
							this.exchangePersonal(dinfo.id, data.relationUserId)
						}
					}else{
						this.appendElm(this.$refs['pedigree-tree-node'], dinfo, true, 0);
						this.rootNode = [dinfo];
					}

					this.clkPersonal(document.querySelector('#clans_'+data.info.id).parentNode)
				}
			},
			afterSavePastinfo(t){
				let clanElm = document.querySelector('#clans_' + this.actionPsrId);
				if(t == "delete"){
					clanElm.setAttribute('class', clanElm.getAttribute('class').replace('past',''));
				}else{
					clanElm.setAttribute('class', clanElm.getAttribute('class')+' past');
				}
				clanElm.querySelector('.head-img').children[0].setAttribute('class',(t == "delete")?'':'past');
			},
			afterSavePedigree(p){
			},
			onResetPwd(){
				this.showSetPwd = true;
				this.pwdVisit = "";
				this.pwdAdmin = "";
			},
			showKeyboard(t){
				if(t==1){
					this.showVisitKeyboard = true;
					if(this.showAdminKeyboard){
						this.$refs['adminKeyboard'].onBlur();
					}
				}else{
					this.showAdminKeyboard = true;
					if(this.showVisitKeyboard){
						this.$refs['visitKeyboard'].onBlur();
					}
				}
			},
			saveResetPwd(){
				var params = {
					u_id: this.u_id,
					token: this.token,
					id: this.pdg_id,
					pwd: {visit:this.pwdVisit,admin:this.pwdAdmin}
				};
				var url = this.Conf.serverUrl + "clans/resetPedigreePwd?num="+Math.random();
				let that = this;
				that.cancleSetPwd();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
						that.$toast.fail(response.data.msg);
						if (response.data.code == 200) {
							that.infoAuth['visit_pwd'] = response.data.data['visit_pwd'];
							that.infoAuth['admin_pwd'] = response.data.data['admin_pwd'];
						}
				})
				.catch(error => {});
			},
			cancleSetPwd(){
				if(this.showVisitKeyboard){
					this.$refs['visitKeyboard'].onBlur();
				}
				if(this.showAdminKeyboard){
					this.$refs['adminKeyboard'].onBlur();
				}
				this.showSetPwd = false;
				this.showChkVisitPwd = false;
				this.showChkAdminPwd = false;
			},
			confirmChkPwd(){
				var params = {
					u_id: this.u_id,
					token: this.token,
					id: this.pdg_id,
					types: this.showChkVisitPwd?'visit':'admin',
					pwd: md5(md5(this.showChkVisitPwd?this.pwdVisit:this.pwdAdmin))
				};
				var url = this.Conf.serverUrl + "clans/chkPedigreePwd?num="+Math.random();
				let that = this;
				that.cancleSetPwd();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
						if (response.data.code == 200) {
							if(response.data.types == "admin"){
								that.$toast.success('输入密码正确！');
								that.canAdminPersonal = true;
								let hisAdminAuth = (localStorage.getItem("clans_admin")||"").split(",");
								hisAdminAuth.push(that.pdg_id);
								localStorage.setItem("clans_admin_pedigree",hisAdminAuth.join(","))
							}else{
								that.canVisitPersonal = true;
								that.loadPedigreePersonal(null,null,0);
								let hisVisitAuth = (localStorage.getItem("clans_visit")||"").split(",");
								hisVisitAuth.push(that.pdg_id);
								localStorage.setItem("clans_visit_pedigree",hisVisitAuth.join(","))
							}
						}else{
							that.$toast.fail(response.data.msg);
						}
				})
				.catch(error => {});
			},
			appendTopElm(obj, qryPsrId, isQryUp, metas){
				let nprt = false;
				if(!document.querySelector('#clans_tb_'+obj.id)){
					nprt = true;
					this.appendElm(this.$refs['pedigree-tree-node'], obj, true, isQryUp);
					if(metas){
						this.addMetaElm(obj.id, metas, isQryUp)
					}

				}

				let tbodyElm = document.querySelector('#clans_tb_'+obj.id).parentNode.parentNode.parentNode;
				document.querySelector('#clans_'+obj.id).parentNode.setAttribute('childs',parseInt(document.querySelector('#clans_'+obj.id).parentNode.getAttribute('childs'))+1);
				let arrDown = document.querySelector('#clans_'+obj.id).querySelector('.fa-chevron-down');
				if(arrDown.getAttribute('class').indexOf('fa-rotate-vertical') == -1){
					arrDown.setAttribute('class',arrDown.getAttribute('class')+' fa-rotate-vertical');
				}
				
				let tdobj = null;
				if(nprt){
					tbodyElm.children[1].setAttribute('class','lines');
					tbodyElm.children[2].setAttribute('class','lines');
					tbodyElm.children[3].setAttribute('class','');
				}else{
					tdobj = document.createElement('td');
					tdobj.setAttribute('class','left top');
					tdobj.innerHTML = "&nbsp;";
					tbodyElm.children[2].insertBefore(tdobj, tbodyElm.children[2].children[tbodyElm.children[2].children.length-1]);

					tdobj = document.createElement('td');
					tdobj.setAttribute('class','right top');
					tdobj.innerHTML = "&nbsp;";
					tbodyElm.children[2].insertBefore(tdobj, tbodyElm.children[2].children[tbodyElm.children[2].children.length-1]);
				}

				tdobj = document.createElement('td');
				tdobj.setAttribute('colspan',2);

				tbodyElm.children[3].appendChild(tdobj);
				tdobj.appendChild(document.querySelector('#clans_tb_'+qryPsrId).parentNode.parentNode.parentNode.parentNode);

				if(document.getElementById('clans_meta_tbody_'+obj.id)){
					document.getElementById('clans_meta_tbody_'+obj.id).children[document.getElementById('clans_meta_tbody_'+obj.id).children.length-1].children[0].setAttribute('class','left leftline top');
					document.getElementById('clans_meta_tbody_'+qryPsrId).children[0].children[1].setAttribute('class','left leftline bottom');
				}
				document.querySelector('#clans_'+qryPsrId).parentNode.setAttribute('up_id', obj.id);
				document.querySelector('#clans_'+qryPsrId).querySelector('.fa-chevron-up').setAttribute('class', document.querySelector('#clans_'+qryPsrId).querySelector('.fa-chevron-up').getAttribute('class')+' fa-rotate-vertical')
			},
			chkDeepInd(id){
				let rst = -1;
				for(var i=0,il=this.deepLoadIds.length; i<il; i++){
					if(this.deepLoadIds[i].indexOf(','+ id +',') > -1){
						rst = i;
						break;
					}
				}
				return rst;
			},
			loadPedigreePersonal(psrId,sex,qryup){
				var params = {
					u_id: this.u_id,
					token: this.token,
					p_id: this.pdg_id,
					p_num: this.infoAuth.pedigree_num,
					pdgonly: this.qryPdgOnly,
					psr_id: psrId,
					sex: sex,
					qryup: qryup||0,
					keyword: this.loadByQry&&!psrId?this.keyword:''
				};
				var url = this.Conf.serverUrl + "clans/pedigreeUser?num="+Math.random();
				let that = this;
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.code == 200) {
						let list = response.data.data;
						let isQryUp = parseInt(response.data.params.qryup);
						let qryPsrId = response.data.params.psr_id;
						if(qryPsrId){
							if(isQryUp){
								if(list && list.length > 0){
									that.appendTopElm(list[0],qryPsrId,isQryUp,response.data.metas);
								}
							}else{
								that.appendRelationshipElm(qryPsrId, response.data.metas, list, isQryUp);
							}
							let curNode = document.querySelector('#clans_' + qryPsrId);
							if(isQryUp){
								curNode.parentNode.setAttribute('qryup','1');
							}else{
								curNode.parentNode.setAttribute('qrydown','1');
							}
							if(that.actionPsrId && !that.loadClansAuto){
								that.clkPersonal(document.querySelector('#clans_'+that.actionPsrId).parentNode);
							}
						}else{
							that.rootNode = list;
							let rIds = '';
							for(var i=0,il=list.length; i<il; i++){
								that.appendElm(that.$refs['pedigree-tree-node'], list[i], true, isQryUp);
								rIds += ','+list[i].id+',';
							}
							that.deepLoadIds.push(rIds);
						}
						if(that.loadClansAuto){
							let dind = qryPsrId?that.chkDeepInd(qryPsrId):-1;
							for(var i=0,il=list.length; i<il; i++){
								if(list[i].nexts && dind<that.initDeep){
									if(dind > -1){
										if(that.deepLoadIds.length == dind+1){
											that.deepLoadIds.push('');
										}
										that.deepLoadIds[dind+1] += ','+list[i].id+',';
									}
									if((qryPsrId && dind>-1)||(!qryPsrId&&dind==-1)){
										that.loadPedigreePersonal(list[i].id, list[i].sex,isQryUp);
									}
								}
							}
						}
						that.loadClansAuto = true;
					}else if(response.data.msg){
						that.$toast.fail(response.data.msg);
					}
				})
				.catch(error => {});
			},
			loadAdpotPersonal(id){
				let rind = -1;
				try{
					rind = document.querySelector('#clans_tb_'+id).parentNode.parentNode.parentNode.parentNode.parentNode.cellIndex;
				}catch(e){}

				let tbElm = document.querySelector('#clans_'+id).parentNode;
				var params = {
					u_id: this.u_id,
					token: this.token,
					psr_id: (id+'').indexOf('_')==-1?id:parseInt((id+'').split('_')[1]),
					adp_id: tbElm.getAttribute('adp_id'),
					rel: tbElm.getAttribute('rel'),
					rind:rind
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/genealogyAdpotPersonal?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.code == 200) {
						that.addChildElm(response.data.psr_id, response.data.datas, 0);
					}
				})
				.catch(error => {});
			},
			loadPedigreeSource(id){
				var params = {
					u_id: this.u_id,
					token: this.token,
					psr_id: id,
					p_num: this.infoAuth.pedigree_num,
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/pedigreeSourceData?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.code == 200) {
						let upsdata = response.data.datas;
						let psr_id = response.data.psr_id;
						let updata = null;
						for(var i=0,il=upsdata.length; i<il; i++){
							updata = upsdata[i];
							updata.sex = "M";
							updata.id = updata.id*-1;
							that.appendTopElm(updata, psr_id, 1, null);
							psr_id = updata.id;
						}
					}
				})
				.catch(error => {});
			},
			searchData(c){
				if(!this.canVisitPersonal){
					this.$toast.fail("您还没有访问权限，请输入访问密码或联系管理员！");
				}
				if(c == 'more'){
					this.$router.push({path:'/Clans/Search',query:{p_id:this.pdg_id,p_num:this.infoAuth.pedigree_num,p_name:this.infoAuth.name,family_name:this.infoAuth.family_name,personal_id:this.infoAuth.personal_id}});
					return false;
				}
				this.$refs['pedigree-tree-node'].innerHTML = '';
				this.srchKeyWord = this.keyword;
				this.qryPdgOnly = c=='clans'?1:0;
				if(this.srchKeyWord){
					this.loadClansAuto = false;
				}else{
					this.deepLoadIds = [];
				}
				this.loadByQry = (this.keyword)?true:false;
				this.loadPedigreePersonal(null,null,0);
			},
			chkInCurrentPedigree(pid){
				if(!this.infoAuth.personal_id || this.infoAuth.personal_id == pid){
					return true;
				}
				if(pid>0){
					let pnode = document.querySelector('#clans_'+pid).parentNode;
					if(pnode.getAttribute('up_id') != '0'){
						return this.chkInCurrentPedigree(pnode.getAttribute('up_id'));
					}
				}
				return false;
			},
			reShowActions(o, statu){
				let ielms = o.querySelectorAll('i');
				if(statu == 'none'){
					for(var i=0,il=ielms.length; i<il; i++){
						ielms[i].style.display = statu;
					}
				}else{
					//if(this.qryPdgOnly) return false;
					let shows = [];
					let p_id = parseInt(o.getAttribute('psr_id'));

					if((!this.qryPdgOnly && o.getAttribute('is_adpot')!=1) && p_id>0 && (this.canAdminPersonal || p_id == this.u_id) && this.chkInCurrentPedigree(p_id)){
						shows.push('fa-chevron-edit');
					}
					if(o.getAttribute('meta')==1){
						if(!this.qryPdgOnly && p_id>0 && this.chkInCurrentPedigree(p_id)){
							shows.push('fa-chevron-child');
						}
					}else{
						if(!this.qryPdgOnly && (o.getAttribute('is_adpot')!=1) && p_id>0 && this.chkInCurrentPedigree(p_id)){
							if(o.getAttribute('sex')=='F'){
								shows.push(o.getAttribute('up_id')>0?'fa-chevron-man2':'fa-chevron-man');
							}else{
								if(o.getAttribute('qrydown')!=null || o.getAttribute('nexts') == 0){
									shows.push('fa-chevron-woman');
								}
								if(o.getAttribute('up_id')==0 && o.getAttribute('ups')==0){
									shows.push('fa-chevron-mother');
								}
							}
						}
						let upElm = document.querySelector('#clans_'+o.getAttribute('up_id'));
						if(upElm){
							upElm = upElm.parentNode;
							if(upElm.getAttribute('childs') > 1){
								shows.push('fa-chevron-left');
							}
						}
						if(o.getAttribute('metas') > 0){
							shows.push('fa-chevron-right');
						}

						if(o.getAttribute('childs') > 0 || ((o.getAttribute('nexts') > 0 || o.getAttribute('qrydown'))&&o.getAttribute('metas') == 0) || o.getAttribute('adpots') > 0){
							shows.push('fa-chevron-down');
						}
						if(o.getAttribute('up_id') > 0 || o.getAttribute('ups') > 0 || o.getAttribute('qryup') || (o.getAttribute('up_id') == '0' || o.getAttribute('ups') == '0' && this.infoAuth.pedigree_source>0)){
							shows.push('fa-chevron-up');
						}

					}

					for(var i=0,il=shows.length; i<il; i++){
						o.querySelector('i.'+shows[i]).style.display = statu;
					}
				}
			},
			addRootClans(){
				if(!this.chkLogined(null)){return false;}
				this.personalInfo = {surname:this.infoAuth.family_name};
				this.relationInfo = {pedigreeId: this.pdg_id}
				this.showAction=true;
			},
			clkPersonal(o){
				let psr_id = isNaN(parseInt(o.getAttribute('psr_id')))?o.getAttribute('psr_id'):parseInt(o.getAttribute('psr_id'));
				let act_statu = "block";
				if(this.actionPsrId){
					if(psr_id == this.actionPsrId){
						act_statu = "none";
					}else{
						this.reShowActions(document.querySelector('#clans_'+this.actionPsrId).parentNode, 'none');
					}
				}
				this.reShowActions(o, act_statu);
				if(act_statu == "none"){
					this.actionTitle = "";
					this.actionPsrId = 0;
					this.actionParams = {};
					return false;
				}

				//psr_id,sex,types(人员类型),in_laws（亲家关系）,meta（外娶人员）,ups（可向上添加）,unmeta（未添加丈夫）
				let sex = o.getAttribute('sex');
				let types = parseInt(o.getAttribute('types'));
				let in_laws = parseInt(o.getAttribute('in_laws'));
				let meta = parseInt(o.getAttribute('meta'));
				let ups = parseInt(o.getAttribute('upds'));
				let pasted = parseInt(o.getAttribute('pasted'));

				this.actionTitle = o.getAttribute('name');
				this.actionPsrId = psr_id;
				this.actionParams = {
					sex:sex,
					types:types,
					in_laws:in_laws,
					meta:meta,
					ups:ups,
					pasted:pasted
				};
			},
			act2Personal(e, t, id){
				if(!this.chkLogined(null)){return false;}
				if(this.actionPsrId && this.actionPsrId==id){
					let curNode = document.querySelector('#clans_'+this.actionPsrId).parentNode;
					if(t == 0){
						this.personalInfo = {id: this.actionPsrId,sex:this.actionParams.sex};
						this.relationInfo = {};
						this.showPastTab = this.actionParams.pasted==0?false:true;
						
						this.personalPopupTab = [false, false, false, false, false, false];
					}else{
						this.personalPopupTab = [true, true, true, true, true, true];
					
						this.personalInfo = {in_laws:this.actionParams.in_laws};
						if(!isNaN(parseInt(curNode.getAttribute('jishi')))){
							this.personalInfo['jishi'] = curNode.getAttribute('jishi');
						}
						this.relationInfo = {pedigreeId: this.pdg_id, relationUserId:this.actionPsrId, in_law:this.actionParams.in_laws, relationShip:t}
						if(t == -1){
							if(!isNaN(parseInt(curNode.getAttribute('jishi')))){
								this.personalInfo['jishi'] = parseInt(curNode.getAttribute('jishi'))-1;
							}
							this.personalInfo['sex'] = 'F';
						}else if(t == 1 || t == 3){
							this.personalInfo['sex'] = this.actionParams.sex=='M'?'F':'M';
						}

						if((t==2 && this.actionParams.in_laws!=1) || (t==1&&this.actionParams.sex=='F')){
							this.personalInfo['surname'] = this.infoAuth.family_name;
						}
						this.showPastTab = false;
					}
					if(t == 2){
						this.showAction = true;

						if(!isNaN(parseInt(curNode.getAttribute('jishi')))){
							this.personalInfo['jishi'] = parseInt(curNode.getAttribute('jishi'))+1;
						}
					}else{
						this.showPersonalPopup = true;
						this.personalActive = 0;
					}
					window.event? window.event.cancelBubble = true : e.stopPropagation();
				}
			},
			onClkOption(opt){
				this.showAction = false;
				if(opt.code == "add_psr"){
					this.personalInfo['sex'] = opt.params['sex'];
					this.showPersonalPopup = true;
					this.personalActive = 0;
				}
			},
			act2ClansChart(e, o, id, t){
				if(this.actionPsrId && this.actionPsrId==id){

					let resetRotateClass = function(o, appCls){
						if(o.getAttribute('class').indexOf(appCls) == -1){
							o.setAttribute('class', o.getAttribute('class') + ' '+appCls);
							return '';
						}else{
							o.setAttribute('class', o.getAttribute('class').replace(' '+appCls,''));
							return 'hidden';
						}
					}

					let hideOrShowLevelChild = function(id, diss){
						//o = o||document.querySelector('#clans_'+id).querySelector('.fa-chevron-left');
						let upTbodyElm = document.querySelector('#clans_tb_'+document.querySelector('#clans_'+id).parentNode.getAttribute('up_id')).parentNode.parentNode.parentNode;
						let tdElms = upTbodyElm.children[2].children;
						for(var i=0,il=tdElms.length; i<il; i++){
							if(!(i==0 || i==(il-1))){
								if(diss == ''){
									tdElms[i].setAttribute('class', tdElms[i].getAttribute('class').replace(' hidden',''));
								}else{
									tdElms[i].setAttribute('class', tdElms[i].getAttribute('class')+' hidden');
								}
							}
						}
						tdElms = upTbodyElm.children[3].children;
						for(var i=0,il=tdElms.length; i<il; i++){
							if(!tdElms[i].querySelector('#clans_tb_'+id)){
								tdElms[i].setAttribute('class',diss);
							}
						}
					}

					let hideOrShowUpline = function(up_id, id, disstr){
						let upTbodyElm = document.querySelector('#clans_tb_'+up_id).parentNode.parentNode.parentNode;
						upTbodyElm.children[0].setAttribute('class','' + disstr);
						upTbodyElm.children[1].setAttribute('class','lines ' + disstr);
						upTbodyElm.children[2].setAttribute('class','lines ' + disstr);
						let metaElm = null;
						if(disstr == ''){
							metaElm = document.querySelector('#clans_meta_tbody_'+up_id);
							if(metaElm){
								metaElm.children[0].children[1].setAttribute('class','bottom');
							}
						}
						metaElm = document.querySelector('#clans_meta_tbody_'+id);
						if(metaElm){
							metaElm.children[0].children[1].setAttribute('class',(disstr == '')?'left leftline bottom':'bottom');
						}
					}

					let hideOrShow2up = function(id,disstr){
						let o = document.querySelector('#clans_'+id).querySelector('.fa-chevron-up');
						let rdisstr = resetRotateClass(o, 'fa-rotate-vertical');
						if(disstr==null){
							disstr = rdisstr;
						}
						if(disstr != rdisstr){
							resetRotateClass(o, 'fa-rotate-vertical');
							return false;
						}
						let leftElm = document.querySelector('#clans_'+id).querySelector('.fa-chevron-left');
						if(disstr == 'hidden'){
							resetRotateClass(leftElm, 'fa-rotate-horizontal');
							hideOrShowLevelChild(id, disstr);
							leftElm.setAttribute('class', leftElm.getAttribute('class')+' hidden');
						}
						if(disstr == '' && leftElm.getAttribute('class').indexOf('hidden') > -1){
							leftElm.setAttribute('class', leftElm.getAttribute('class').replace(' hidden',''));
						}
						let up_id = document.querySelector('#clans_'+id).parentNode.getAttribute('up_id');
						if(up_id && up_id != 'undefined'){
							if(disstr=='hidden'){
								hideOrShow2up(up_id,disstr);
							}
							hideOrShowUpline(up_id, id, disstr);
						}
					}

					let tbElm = null;
					let dis = '';
					switch(t){
						case 'up':
							tbElm = document.querySelector('#clans_'+id).parentNode;
							if(tbElm.getAttribute('up_id')==0 && tbElm.getAttribute('ups')>0){
								if(!this.chkLogined('登录后可以查看更多')){ return false;}
								this.loadClansAuto = false;
								this.loadPedigreePersonal(id, tbElm.getAttribute('sex'), 1);
							}else if(tbElm.getAttribute('up_id')==0 && tbElm.getAttribute('ups')==0){
								if(!this.chkLogined('登录后可以查看更多')){ return false;}
								this.loadPedigreeSource(id);
							}else{
								hideOrShow2up(id,null);
							}

							break;
						case 'down':
							tbElm = document.querySelector('#clans_'+id).parentNode;
							if(tbElm.getAttribute('childs')==0){
								if(!this.chkLogined('登录后可以查看更多')){ return false;}

								this.loadClansAuto = false;
								if(tbElm.getAttribute('nexts')>0){
									this.loadPedigreePersonal(id, tbElm.getAttribute('sex'), 0);
								}
								if(tbElm.getAttribute('adpots')>0){
									this.loadAdpotPersonal(id);
								}
							}else{
								dis = resetRotateClass(o, 'fa-rotate-vertical');

								let tbobj = document.getElementById('clans_tb_'+id);
								let tbodyObj = tbobj.parentNode.parentNode.parentNode;

								tbodyObj.children[1].setAttribute('class','lines ' + dis);
								tbodyObj.children[2].setAttribute('class','lines ' + dis);
								tbodyObj.children[3].setAttribute('class','' + dis);
								document.getElementById('clans_meta_tbody_'+id).children[document.getElementById('clans_meta_tbody_'+id).children.length-1].children[0].setAttribute('class',dis==''?'left leftline top':'top');

							}

							break;
						case 'right':
							let metaElm = document.querySelector('#clans_meta_'+id);
							dis = resetRotateClass(o, 'fa-rotate-horizontal');
							metaElm.setAttribute('class', dis);

							break;
						default:
							dis = resetRotateClass(o, 'fa-rotate-horizontal');

							hideOrShowLevelChild(id, dis);

							break;
					}
					window.event? window.event.cancelBubble = true : e.stopPropagation();
				}
			},
			showPedigreeSource(){
				this.showPedigreeSourcePopup = true;
			},
			deletePedigree(){
				var params = {
					u_id:this.u_id,
					token:this.token,
					p_id: this.pdg_id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/pedigreeDelete" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.$router.push({path:'/Clans'});
					}
				})
				.catch(error => {});
			},
			buildGenealogyBook(){
				this.showGenealogyBookPopup = true;
			},
			onAddChildPedigree(psrId,name){
				this.pedigreeInfo = {
					parent_id:this.pdg_id,
					personal_id:psrId,
					name:name,
					family_name:this.infoAuth.family_name,
					num:this.infoAuth.pedigree_num
				};
				this.imgList = [{url:this.coverImg, isImage: true}];
				this.editPedigreeInfo = false;
				this.showEditInfo = true;
			},
			onAddParentPedigree(){
				this.pedigreeInfo = {
					child_id:this.pdg_id,
					personal_id:this.infoAuth.personal_id,
					family_name:this.infoAuth.family_name,
					num:this.infoAuth.pedigree_num
				};
				this.imgList = [{url:this.coverImg, isImage: true}];
				this.editPedigreeInfo = false;
				this.showEditInfo = true;
			},
			shareGenealogyBook(){
				this.showShareSheet = true;
			}
		},
		created() {
			this.$parent.code = "tree";
			this.pdg_id = this.$route.params.p_id;
			this.getStateConfigs();
			
			let isWxEnv = chkWeiXin();
			this.shareQRCodeUrl = isWxEnv?location.href:(this.Conf.clientOrigin+'/m/#/Clans/Chart/' + this.pdg_id);

			this.chkPedigreeAuth();
			
			let options = [];
			options.push({ name: '添加♂', icon: require("../../assets/img/clans/boy.png"),  code:'add_psr', params:{sex:'M'} });
			options.push({ name: '添加♀', icon: require("../../assets/img/clans/gril.png"),  code:'add_psr', params:{sex:'F'} });
			this.actionOptions = options;

			/**
			let that = this;
			this.$nextTick(() => {
			});
			*/

			window.clkPersonal = this.clkPersonal;
			window.act2Personal = this.act2Personal;
			window.act2ClansChart = this.act2ClansChart;

		}
	};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Clans/PedigreeChart.vue